import { httpClient } from "@/http";
import { BalanceRead, WalletRead, WalletTransfer, WalletUpdate } from "./types";

export const MyWalletService = {
  list() {
    return httpClient<HttpPaginationResponse<{ wallets: WalletRead[] }>>()
      .get("/api/v1/user/me/wallets")
      .timeout(30000);
  },
  update(walletId: string, data: WalletUpdate) {
    return httpClient().patch(`/api/v1/user/me/wallets/${walletId}`, data);
  },
  collect(walletId: string) {
    return httpClient().post(`/api/v1/user/me/wallets/${walletId}/collect`);
  },
  transfer(walletId: string, data: WalletTransfer) {
    return httpClient().post(
      `/api/v1/user/me/wallets/${walletId}/transfer`,
      data
    );
  },
};

export const MyBalanceService = {
  list() {
    return httpClient<HttpResponse<{ balances: BalanceRead[] }>>().get(
      "/api/v1/user/me/balances"
    );
  },
};
